export const PENDING_APPLICANTS_FIRST_BATCH_SIZE = 12;
export const PENDING_APPLICANTS_NEXT_BATCH_SIZE = 6;
